import {
    BANKACCOUNT_UPSERT_SUCCESS,
    BANKACCOUNT_GETALL_SUCCESS,
    BANKACCOUNT_DELETE_SUCCESS
  } from "../actions/types";
  
  const initialState = { bankaccounts: null }
  
  export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case BANKACCOUNT_UPSERT_SUCCESS:
        if (state.bankaccounts.filter(e => e.id == payload.id).length > 0) {
          return { ...state, bankaccounts: state.bankaccounts.map(bankaccount => { return bankaccount.id === payload.id ? payload : bankaccount }) };
        } else {
          return { ...state, bankaccounts: [...state.bankaccounts, payload] }
        }
      case BANKACCOUNT_DELETE_SUCCESS:
        return { ...state, bankaccounts: state.bankaccounts.filter(bankaccount => bankaccount.id !== payload) }
  
      case BANKACCOUNT_GETALL_SUCCESS:
        return { ...state, bankaccounts: payload.bankaccounts };
      default:
        return { ...state };
    }
  }